import {
  Box,
  Flex,
  Group,
  NumberFormatter,
  Text,
  Tooltip,
} from '@mantine/core';
import { safeCastNumber } from 'utils/numberUtils';
import { useProviderDashboardPalette } from './useProviderDashboardPalette';

export const StatusRow = ({
  label,
  value,
  onClick,
  color,
  tooltip,
}: {
  label: string;
  value: number;
  onClick?: () => void;
  color: string;
  tooltip?: string;
}) => {
  const hasTooltip = Boolean(tooltip);
  const palette = useProviderDashboardPalette();

  return (
    <Flex
      align="center"
      justify="space-between"
      py={8}
      style={{
        borderBottom: `1px solid ${palette.divider}`,
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      <Group gap={8}>
        <Box
          style={{
            width: 8,
            height: 8,
            borderRadius: 999,
            background: color,
            flexShrink: 0,
          }}
        />
        <Tooltip
          label={tooltip}
          disabled={!hasTooltip}
          withArrow
          multiline
          w={220}
          position="top-start"
        >
          <Group gap={6}>
            <Text
              size="sm"
              c={palette.secondaryText}
              style={{
                cursor: hasTooltip ? 'help' : undefined,
              }}
            >
              {label}
            </Text>
            {hasTooltip ? (
              <Box
                component="span"
                style={{
                  width: 14,
                  height: 14,
                  borderRadius: 999,
                  border: `1px solid ${palette.hintBorder}`,
                  color: palette.hintText,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 9,
                  fontWeight: 700,
                  lineHeight: 1,
                  cursor: 'help',
                  flexShrink: 0,
                }}
              >
                ?
              </Box>
            ) : null}
          </Group>
        </Tooltip>
      </Group>
      <NumberFormatter
        prefix="$"
        value={safeCastNumber(value)}
        thousandSeparator
        decimalScale={2}
        fixedDecimalScale
        style={{
          fontSize: 15,
          fontWeight: 600,
          color: palette.primaryText,
        }}
      />
    </Flex>
  );
};
